<template>
  <div class="page-form">
    <h3 class="title">发货对账单</h3>
    <step-1 v-show="step == 1" @check="changeStep" />
    <step-2 v-if="step != 1" :params="conditions" @check="changeStep" />
  </div>
</template>

<script>
import step1 from './components/DeliverCheckStep1.vue'
import step2 from './components/DeliverCheckStep2.vue'
export default {
  components: {
    step1,
    step2
  },
  data() {
    return {
      step: 1,
      conditions: {
        'endday': '',
        'startday': '',
        'warehouse': ''
      }
    }
  },
  methods: {
    changeStep(conditions) {
      if (conditions) {
        Object.assign(this.conditions, conditions)
        this.step = 2
      } else {
        this.step = 1
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/deliveryCheckProcess.vue